import { render, staticRenderFns } from "./supplier-detail-receive-info.vue?vue&type=template&id=0148154e&scoped=true&"
import script from "./supplier-detail-receive-info.vue?vue&type=script&lang=js&"
export * from "./supplier-detail-receive-info.vue?vue&type=script&lang=js&"
import style0 from "./supplier-detail-receive-info.vue?vue&type=style&index=0&id=0148154e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0148154e",
  null
  
)

export default component.exports